<div class="flex flex-wrap mt-8 mb-6">

    @let album = (album$ | async);

    <div class="w-full flex flex-row justify-between mb-4">
        <app-btn-back routeTo=".."></app-btn-back>
    </div>

    <div class="mb-4 border-0 w-full">
        <h1 class="font-semibold text-2xl capitalize transition-colors duration-300"
            [class.text-primary-500]="!(loadingAlbum$ | async)"
            [class.animate-pulse]="(loadingAlbum$ | async) && (albumColumns$ | async)?.length === 0"
            [class.text-slate-200]="loadingAlbum$ | async">
            {{ album?.albumName }}
        </h1>
        <span class="text-sm font-light text-primary-300">
            Total Images: {{ album?.totalImages ?? '-' }} ({{ album?.totalBytes ? (album?.totalBytes! / (1024 *
            1024)).toFixed(2) + ' MB' : '-' }})
        </span>
    </div>

    <div class="w-full mb-4">

        <div class="flex flex-row gap-4 items-start w-full">
            @for (column of albumColumns$ | async; track $index) {
            <div class="flex flex-col gap-4 flex-1">
                @for (image of column; track image.id) {
                <div
                    class="relative w-full rounded-xl overflow-hidden bg-slate-100 shadow-sm transition-transform duration-300 hover:shadow-md">

                    <div [style.aspect-ratio]="image.aspectRatio"
                        [style.background-color]="image.dominantColor || 'bg-slate-200'" class="relative w-full">

                        @if (!loadedImages.has(image.id!)) {
                        <div class="absolute inset-0 bg-white/40 animate-pulse"></div>
                        }

                        <img [src]="image.variants?.mobile" (load)="onImageLoad(image.id!)"
                            class="w-full h-auto block transition-opacity duration-500"
                            [class.opacity-0]="!loadedImages.has(image.id!)"
                            [class.opacity-100]="loadedImages.has(image.id!)" (click)="showImage(image)" />

                        @if (canManageCover() && loadedImages.has(image.id!)) {
                        <div class="absolute top-0 left-0 z-20 pointer-events-none overflow-hidden w-24 h-24">
                            <div (click)="album?.albumCoverUrl !== image.variants?.mobile && setAsCover(image); $event.stopPropagation()"
                                class=" pointer-events-auto cursor-pointer text-white text-[11px] font-bold py-0.5 shadow-md
                                            absolute top-4 left-[-30px] w-32 rotate-[-45deg] flex justify-center items-center 
                                             transition-colors tracking-wider" [class]="album?.albumCoverUrl == image.variants?.mobile ? 'bg-green-500' : 'bg-amber-500
                                hover:bg-amber-600'">
                                @if (album?.albumCoverUrl == image.variants?.mobile) {
                                <span><i class="fa fa-star mr-1"></i>Cover</span>
                                } @else {
                                <span>Set Cover</span>
                                }
                            </div>
                        </div>

                        <app-btn-fab (click)="deleteImage(image)" icon="fa fa-trash-can"
                            [isDisabled]="(inProgress$ | async) ?? false" [position]="btnFabPosition"
                            class="absolute top-1 right-1 z-10 p-1"
                            colors="bg-primary-300/50 hover:bg-gray-100 text-gray-100 hover:text-red-500"
                            tooltip="Delete"></app-btn-fab>
                        }
                    </div>
                </div>
                }
            </div>
            }
        </div>

        @let loadingAlbum = (loadingAlbum$ | async) ?? false;
        <div class="flex flex-row w-full justify-center px-4 mt-3">
            <app-btn-more (click)="addMoreImages()" [isDisabled]="loadingAlbum"
                [inProgress$]="loadingAlbum$"></app-btn-more>
        </div>
    </div>
</div>